export default __webpack_public_path__ + "static/media/SIP.a1162afb.svg";